export function shadowRoot() {
  const host = document.getElementById("botbrains-shadow-host");
  const shadowRoot = host?.shadowRoot;
  if (!shadowRoot) {
    throw new Error("[botbrains]: Shadow root not found");
  }
  return shadowRoot;
}
